<template>
    <component
        :is="tag"
        :class="`font-${type}`"
    >
        <slot>{{ text }}</slot>
    </component>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { HeadingType } from './Heading.types';

/**
 * A component mainly needed for builder.io or if you want to be fancy.
 * Otherwise, specify h* tags directly inside the codebase, which is more efficient.
 */
export default defineComponent({
    name: 'Heading',
    props: {
        /** Heading tag for SEO */
        tag: {
            type: String as PropType<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>,
            default: 'h1',
        },
        /** Heading type for design */
        type: {
            type: String as PropType<HeadingType>,
            default: 'heading-1',
        },
        /** Heading text */
        text: {
            type: String,
            default: '',
        },
    },
});
</script>
